import { register } from 'register-service-worker';

export default function registerServiceWorker() {
  const publicUrl = process.env.PUBLIC_URL || 'http://localhost:3001';
  register(`${publicUrl}/service-worker.js`, {
    updated(registration) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    }
  });
}